import React, { useContext } from 'react';
import useSectionStyles from './styles';
import PageContext from '../../contexts/pageContext';

const TextSection = ({ sectionData }) => {
  const {
    layout: { containerWidth },
    isMobile
  } = useContext(PageContext);
  const classes = useSectionStyles({ containerWidth, isMobile });
  const [nodeData] = sectionData.components;

  return (
    <>
      <section className={classes.section}>
        <div className={classes.sectionContainer}>
          <div className={classes.subHeading}>
            <span
              ref={nodeData?.subHeading?.refSetter}
              dangerouslySetInnerHTML={{
                __html: nodeData.subHeading.metadata.value
              }}
            />
          </div>
          <h2 className={classes.title}>
            <span
              ref={nodeData?.title?.refSetter}
              dangerouslySetInnerHTML={{
                __html: nodeData.title.metadata.value
              }}
            />
          </h2>
          <div className={classes.textContent}>
            <p
              ref={nodeData?.textLeft?.refSetter}
              className={classes.textPara}
              dangerouslySetInnerHTML={{
                __html: nodeData.textLeft.metadata.value
              }}
            />
            <p
              ref={nodeData?.textRight?.refSetter}
              className={classes.textPara}
              dangerouslySetInnerHTML={{
                __html: nodeData.textRight.metadata.value
              }}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default TextSection;
